module.exports = __webpack_public_path__ + "img/logo.cc274147.svg";